import React, { type JSX } from 'react'
import classNames from 'classnames'
import SvgAvailability from '../../svg/availability.svg'
import { IconProps } from '../icon-props'

const AvailabilityIcon = ({
  className = '',
  multiLayered = false,
  ...props
}: IconProps): JSX.Element | null => (
  <SvgAvailability
    {...props}
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    className={classNames('i-availability', className, {
      'i-multi-layered': multiLayered,
    })}
  />
)

export default AvailabilityIcon
